// mf-modal.js: Reusable modal logic for markdown modals
function createGitHubHeadingIdRenderer() {
    // Custom heading renderer using GitHub-style slugification for anchor IDs
    var renderer = new marked.Renderer();
    renderer.heading = function({ text, depth, raw }) {
        // GitHub slugification: lowercase, remove special chars, 
        // replace spaces with hyphens, collapse multiple hyphens
        var slug = raw.toLowerCase().replace(/[^\w\s-]/g, '') // Remove special chars, keep alphanumeric, spaces, hyphens
        .trim().replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-') // Collapse multiple hyphens into one
        .replace(/^-+|-+$/g, ''); // Trim hyphens from edges
        return '<h' + depth + ' id="' + slug + '">' + text + '</h' + depth + '>\n';
    };
    return renderer;
}
function renderMarkdownToElement(markdownContent, elementId) {
    try {
        var html = marked.parse(markdownContent, {
            renderer: createGitHubHeadingIdRenderer(),
            headerIds: true,
            mangle: false,
            gfm: true
        });
        document.getElementById(elementId).innerHTML = html;
    } catch (error) {
        console.error('Error rendering markdown:', error);
        document.getElementById(elementId).innerHTML = '<p>Error loading content: ' + error.message + '</p>';
    }
}
function createMarkdownModalByTargetName(target) {
    // target: The name of the content we are targeting - e.g. "terms"
    var params = new URLSearchParams(window.location.search);
    var autoOpen = params.get('show') === `${target}`;
    createMarkdownModal({
        modalId: `${target}-modal`,
        contentId: `${target}-md-html`,
        openBtnId: `open-${target}-modal`,
        closeBtnId: `close-${target}-modal`,
        markdownPath: `${target}.md`,
        autoOpen: autoOpen
    });
}
function createMarkdownModal({ modalId, contentId, openBtnId, closeBtnId, markdownPath, autoOpen// Whether the modal should open automatically
 }) {
    document.addEventListener('DOMContentLoaded', function() {
        var openBtn = document.getElementById(openBtnId);
        var modal = document.getElementById(modalId);
        var closeBtn = document.getElementById(closeBtnId);
        // Apply frosted glass style
        modal.classList.add('style-glass');
        function openModal() {
            modal.style.display = 'flex';
            fetch(markdownPath).then(function(response) {
                return response.text();
            }).then(function(md) {
                renderMarkdownToElement(md, contentId);
            }).catch(function(error) {
                console.error('Error fetching markdown:', error);
                document.getElementById(contentId).innerHTML = '<p>Error fetching content.</p>';
            });
        }
        if (openBtn && modal && closeBtn) {
            openBtn.onclick = openModal;
            closeBtn.onclick = function() {
                modal.style.display = 'none';
            };
            window.addEventListener('click', function(e) {
                if (e.target === modal) modal.style.display = 'none';
            });
            document.addEventListener('keydown', function(event) {
                if (event.key === 'Escape' || event.key === 'Esc') {
                    if (modal && modal.style.display != 'none') {
                        event.preventDefault();
                        closeBtn.click();
                    }
                }
            });
            if (autoOpen) openModal();
        }
    });
}

//# sourceMappingURL=404.d84346d2.js.map
